// Keep push navigation on the origin where this PWA is installed and signed in.
export function notificationUrl(value, origin = window.location.origin) {
  try {
    const url = new URL(value, origin);
    if ([origin, 'https://golf.juanjorc.com', 'https://golf-webapp-front.onrender.com'].includes(url.origin)) {
      return origin + url.pathname + url.search + url.hash;
    }
  } catch { /* Malformed/untrusted notification destinations open the app home. */ }
  return origin + '/';
}
